var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 347.457031 160 L 94.390625 160 C 94.390625 160 147.703125 107.011719 149.109375 105.199219 C 152.769531 100.503906 154.964844 94.617188 154.964844 88.210938 C 154.964844 81.128906 152.292969 74.695312 147.925781 69.785156 L 145.6875 67.542969 C 140.792969 63.171875 134.355469 60.488281 127.28125 60.488281 C 120.011719 60.488281 113.40625 63.332031 108.464844 67.929688 C 108.464844 67.929688 6.355469 169.988281 5.835938 170.660156 C 2.222656 175.34375 0.0546875 181.1875 0.0546875 187.570312 C 0.0546875 193.933594 2.222656 199.785156 5.828125 204.457031 C 7.289062 206.351562 109.738281 308.476562 109.738281 308.476562 C 114.488281 312.335938 120.539062 314.648438 127.136719 314.648438 C 142.421875 314.648438 154.820312 302.246094 154.820312 286.945312 C 154.820312 280.230469 152.4375 274.074219 148.472656 269.28125 L 94.390625 215.140625 L 347.457031 215.140625 C 362.667969 215.140625 374.996094 202.789062 374.996094 187.570312 C 374.996094 172.339844 362.667969 160 347.457031 160 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/backbutton.ddb255f9d30522d70a6e06469b33e8be.svg";
export { ForwardRef as ReactComponent };